import { api as convexApi } from "@teachloop/backend/_generated/api";

export const api = convexApi.api.app;
export const auth = convexApi.auth;
